// src/slices/tenantManagement/thunk.ts
// Async thunks for Tenant Management

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getTenants,
  getTenantById,
  createTenant,
  updateTenant,
  deleteTenant,
  checkTenantCode,
} from 'helpers/fakebackend_helper';
import { CreateTenantDto, UpdateTenantDto } from 'pages/TenantManagement/types';

interface GetTenantsParams {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: string;
  parentId?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

// Fetch tenants list
export const fetchTenants = createAsyncThunk(
  'TenantManagement/fetchTenants',
  async (params: GetTenantsParams = {}, { rejectWithValue }) => {
    try {
      const response = await getTenants(params);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi tải danh sách đơn vị'
      );
    }
  }
);

// Fetch tenant detail
export const fetchTenantDetail = createAsyncThunk(
  'TenantManagement/fetchTenantDetail',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getTenantById(id);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi tải thông tin đơn vị'
      );
    }
  }
);

// Create new tenant
export const createNewTenant = createAsyncThunk(
  'TenantManagement/createTenant',
  async (data: CreateTenantDto, { rejectWithValue }) => {
    try {
      const response = await createTenant(data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi tạo đơn vị'
      );
    }
  }
);

// Update existing tenant
export const updateExistingTenant = createAsyncThunk(
  'TenantManagement/updateTenant',
  async ({ id, data }: { id: number; data: UpdateTenantDto }, { rejectWithValue }) => {
    try {
      const response = await updateTenant(id, data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi cập nhật đơn vị'
      );
    }
  }
);

// Delete tenant
export const deleteTenantById = createAsyncThunk(
  'TenantManagement/deleteTenant',
  async (id: number, { rejectWithValue }) => {
    try {
      await deleteTenant(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi xóa đơn vị'
      );
    }
  }
);

// Check code availability
export const checkCode = createAsyncThunk(
  'TenantManagement/checkCode',
  async ({ code, excludeId }: { code: string; excludeId?: number }, { rejectWithValue }) => {
    try {
      const response = await checkTenantCode(code, excludeId);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || 'Có lỗi xảy ra khi kiểm tra mã đơn vị'
      );
    }
  }
);